import React from 'react';
import { Typography } from 'fronton-react';
import { useTranslation } from 'react-i18next';
import { LockSimpleIcon } from '@fronton/icons-react';
import { DeliveryOptionIcon } from './delivery-option-icon';
import { delivOpt, delivOptIconCntr, delivOptTextContent } from './delivery-option.styles';

type DeliveryOptionUnavailableProps = {
  type: string;
} & React.HTMLAttributes<HTMLElement>;

export const DeliveryOptionUnavailable: React.FC<DeliveryOptionUnavailableProps> = ({ type }) => {
  const { t } = useTranslation();
  const deliveryMethod =
    type === 'HOME_DELIVERY'
      ? t('product-info.delivery.by-courier')
      : t('product-info.delivery.to-pickup-point');
  return (
    <div className={delivOpt}>
      <div className={delivOptIconCntr}>
        <DeliveryOptionIcon type={type} color="text-minor" />
      </div>
      <div className={delivOptTextContent}>
        <Typography variant="s" size="body_long" color="text-minor">
          {t('product-info.delivery.delivery-unavailable-text', { to: deliveryMethod })}
        </Typography>
        <LockSimpleIcon type={'duotone'} size="l" color="text-minor" />
      </div>
    </div>
  );
};
